import moment from 'moment';
import { formatDate } from 'data/projects/gantt/dates';
import { extractParts } from 'data/projects/phase-entity';
import { isPrereleaseFeatureEnabled, PrereleaseFeature } from 'hooks/use-feature';
import { DependencyTypesEnum, DependencyTypesEnumReverse, EntityType } from './date-shift';
export const getPhaseList = (phases)=>{
    const result = {};
    phases.forEach(({ projectPhaseId, projectPhaseName, startDay, duration, entityOrder, dependentProjectPhases })=>{
        var _ref;
        result[projectPhaseId] = {
            depth: 0,
            id: projectPhaseId,
            name: projectPhaseName,
            type: EntityType.Phase,
            startDate: formatDate(moment().add(startDay, 'day')),
            dueDate: formatDate(moment().add(startDay + duration - 1, 'day')),
            duration,
            children: (_ref = entityOrder === null || entityOrder === void 0 ? void 0 : entityOrder.map((entityId)=>extractParts(entityId).id)) !== null && _ref !== void 0 ? _ref : [],
            dependentOn: dependentProjectPhases === null || dependentProjectPhases === void 0 ? void 0 : dependentProjectPhases.map(({ projectPhaseId: dPhaseId, dependencyType, lag })=>{
                return {
                    id: dPhaseId,
                    dependencyType: dependencyType ? DependencyTypesEnum[dependencyType] : 2,
                    lag: lag !== null && lag !== void 0 ? lag : null
                };
            })
        };
        dependentProjectPhases === null || dependentProjectPhases === void 0 ? void 0 : dependentProjectPhases.forEach(({ projectPhaseId: dPhaseId, dependencyType, lag })=>{
            var _result_dPhaseId, _ref;
            var _result_dPhaseId1;
            result[dPhaseId] = {
                ...(_result_dPhaseId = result[dPhaseId]) !== null && _result_dPhaseId !== void 0 ? _result_dPhaseId : {},
                dependencyFor: [
                    ...(_ref = (_result_dPhaseId1 = result[dPhaseId]) === null || _result_dPhaseId1 === void 0 ? void 0 : _result_dPhaseId1.dependencyFor) !== null && _ref !== void 0 ? _ref : [],
                    // projectPhaseId,
                    {
                        id: projectPhaseId,
                        dependencyType: dependencyType ? DependencyTypesEnum[dependencyType] : 2,
                        lag: lag !== null && lag !== void 0 ? lag : null
                    }
                ]
            };
        });
    });
    return result;
};
/** Empty placeholder rows are isNew with no name — exclude those from date-shift. */ const isDateShiftTask = (task, includeNamedNewTasks)=>{
    var _task_taskName;
    return includeNamedNewTasks ? !task.isNew || Boolean((_task_taskName = task.taskName) === null || _task_taskName === void 0 ? void 0 : _task_taskName.trim()) : !task.isNew;
};
export const getTaskList = (tasks, options)=>{
    var _ref;
    const includeNamedNewTasks = (_ref = options === null || options === void 0 ? void 0 : options.includeNamedNewTasks) !== null && _ref !== void 0 ? _ref : isPrereleaseFeatureEnabled(PrereleaseFeature.TemplateAgentChat, true);
    const result = {};
    tasks.filter((task)=>isDateShiftTask(task, includeNamedNewTasks)).forEach(({ taskId, startDay, duration, subTasks, dependentTasks, parentTask, projectPhase, taskName })=>{
        var _result_taskId, _ref;
        result[taskId] = {
            ...(_result_taskId = result[taskId]) !== null && _result_taskId !== void 0 ? _result_taskId : {},
            depth: 1,
            name: taskName,
            id: taskId,
            type: EntityType.Task,
            startDate: formatDate(moment().add(startDay, 'day')),
            dueDate: formatDate(moment().add(startDay + duration - 1, 'day')),
            duration,
            children: subTasks === null || subTasks === void 0 ? void 0 : subTasks.map((_task)=>{
                var _ref;
                return (_ref = _task === null || _task === void 0 ? void 0 : _task.taskId) !== null && _ref !== void 0 ? _ref : _task;
            }),
            parent: (_ref = parentTask === null || parentTask === void 0 ? void 0 : parentTask.taskId) !== null && _ref !== void 0 ? _ref : projectPhase === null || projectPhase === void 0 ? void 0 : projectPhase.projectPhaseId
        };
        dependentTasks === null || dependentTasks === void 0 ? void 0 : dependentTasks.forEach(({ taskId: dTaskId, dependencyType, lag })=>{
            if (dependencyType !== undefined && dependencyType !== null) {
                var _result_dTaskId, _ref, _result_taskId, _ref1;
                var _result_dTaskId1, _result_taskId1;
                result[dTaskId] = {
                    ...(_result_dTaskId = result[dTaskId]) !== null && _result_dTaskId !== void 0 ? _result_dTaskId : {},
                    dependencyFor: [
                        ...(_ref = (_result_dTaskId1 = result[dTaskId]) === null || _result_dTaskId1 === void 0 ? void 0 : _result_dTaskId1.dependencyFor) !== null && _ref !== void 0 ? _ref : [],
                        {
                            id: taskId,
                            dependencyType: DependencyTypesEnum[dependencyType],
                            lag: lag !== null && lag !== void 0 ? lag : null
                        }
                    ]
                };
                result[taskId] = {
                    ...(_result_taskId = result[taskId]) !== null && _result_taskId !== void 0 ? _result_taskId : {},
                    dependentOn: [
                        ...(_ref1 = (_result_taskId1 = result[taskId]) === null || _result_taskId1 === void 0 ? void 0 : _result_taskId1.dependentOn) !== null && _ref1 !== void 0 ? _ref1 : [],
                        {
                            id: dTaskId,
                            dependencyType: DependencyTypesEnum[dependencyType],
                            lag: lag !== null && lag !== void 0 ? lag : null
                        }
                    ]
                };
            }
        });
    });
    const getDepth = (id)=>{
        var _result_id;
        return !((_result_id = result[id]) === null || _result_id === void 0 ? void 0 : _result_id.parent) ? 0 : getDepth(result[id].parent) + 1;
    };
    Object.values(result).forEach((_task)=>{
        result[_task.id] = {
            ..._task,
            depth: getDepth(_task.id)
        };
    });
    return result;
};
export const getSprintList = (sprints)=>{
    const result = {};
    sprints.filter(({ isNew })=>!isNew).forEach(({ sprintId, startDay, duration, projectPhase, sprintName })=>{
        var _result_sprintId;
        result[sprintId] = {
            ...(_result_sprintId = result[sprintId]) !== null && _result_sprintId !== void 0 ? _result_sprintId : {},
            depth: 1,
            name: sprintName,
            id: sprintId,
            type: EntityType.Sprint,
            startDate: formatDate(moment().add(startDay, 'day')),
            dueDate: formatDate(moment().add(startDay + duration - 1, 'day')),
            duration,
            children: [],
            dependentOn: [],
            parent: projectPhase === null || projectPhase === void 0 ? void 0 : projectPhase.projectPhaseId
        };
    });
    const getDepth = (id)=>{
        var _result_id;
        return !((_result_id = result[id]) === null || _result_id === void 0 ? void 0 : _result_id.parent) ? 0 : getDepth(result[id].parent) + 1;
    };
    Object.values(result).forEach((_task)=>{
        result[_task.id] = {
            ..._task,
            depth: getDepth(_task.id)
        };
    });
    return result;
};
export const getTemplatePhaseUpdates = (list, phaseList)=>{
    const updates = [];
    Object.values(list).forEach(({ id, startDate, dueDate, dependentOn })=>{
        updates.push({
            projectPhaseId: id,
            startDate: startDate ? moment(startDate).format() : undefined,
            dueDate: dueDate ? moment(dueDate).format() : undefined,
            dependentProjectPhases: dependentOn != null ? dependentOn === null || dependentOn === void 0 ? void 0 : dependentOn.map((_dep)=>({
                    projectPhaseId: _dep.id,
                    projectPhaseName: phaseList ? phaseList[_dep.id].name : '',
                    dependencyType: _dep.dependencyType !== undefined && _dep.dependencyType !== null ? DependencyTypesEnumReverse[_dep.dependencyType] : undefined,
                    lag: _dep.lag
                })) : []
        });
    });
    return updates;
};
export const getTemplateTaskUpdates = (updateList, taskList)=>{
    const updates = [];
    Object.values(updateList).forEach(({ id, startDate, dueDate, dependentOn })=>{
        updates.push({
            taskId: id,
            startDate: startDate ? moment(startDate).format() : undefined,
            dueDate: dueDate ? moment(dueDate).format() : undefined,
            dependentTasks: dependentOn === null || dependentOn === void 0 ? void 0 : dependentOn.map((_dep)=>({
                    taskId: _dep.id,
                    taskName: taskList[_dep.id].name,
                    dependencyType: _dep.dependencyType !== undefined && _dep.dependencyType !== null ? DependencyTypesEnumReverse[_dep.dependencyType] : undefined,
                    lag: _dep.lag
                }))
        });
    });
    return updates;
};
export const getTemplateSprintUpdates = (updateList)=>{
    const updates = [];
    Object.values(updateList).forEach(({ id, startDate, dueDate })=>{
        updates.push({
            sprintId: id,
            startDate: startDate ? moment(startDate).format() : undefined,
            dueDate: dueDate ? moment(dueDate).format() : undefined
        });
    });
    return updates;
};
export const isValidDateShift = (phaseUpdatesList)=>{
    const earliestDate = Object.values(phaseUpdatesList).reduce((prev, update)=>prev === null || update.startDate && moment(update.startDate).isBefore(moment(prev)) ? update.startDate : prev, null);
    if (earliestDate === null) {
        return true;
    }
    return moment().startOf('day').diff(moment(earliestDate), 'day', true) < 0;
};
